<template>
  <div v-if="result" class="product-modal" @click="handlerClick(result)">
    <a :href="result.detailPage">
      <DefImg :result="result.picture" />
    </a>

    <div class="product-modal-description">
      <a :href="result.detailPage" class="product-modal-description__name">
        {{ result.type }}
      </a>
      <span v-if="result.collection" class="product-modal-description__collection">
        {{ result.collection.name }}
      </span>
      <p class="product-modal-description__article">{{ messages.art }}{{ result.article }}</p>
    </div>
    <div
      v-if="result.skuMatrix && result.skuMatrix.SIZES"
      class="product-modal-prop product-modal-size"
    >
      <p class="product-modal-prop__name">
        {{ result.skuMatrix.SIZES.title }}
      </p>
      <p v-if="getActiveSize" class="product-modal-prop__value">
        {{ getActiveSize.name }}
      </p>
    </div>
    <div class="product-modal-prop product-modal-count">
      <p class="product-modal-prop__name">
        {{ messages.quantity }}
      </p>
      <p class="product-modal-prop__value">
        {{ result?.price?.quantity }}
      </p>
    </div>
    <div v-if="result.price" class="product-modal-prices">
      <DefPriceOld v-if="result.price.printPriceOld">
        {{ result.price.printPriceOld }}
      </DefPriceOld>

      <DefPrice v-if="result.price.printPrice">
        {{ result.price.printPrice }}
      </DefPrice>
      <DefPriceEN>
        {{ result?.price?.printPriceEUR }}
      </DefPriceEN>
      <DefSale v-if="result.price.printDiscountPercent">
        {{ result.price.printDiscountPercent }}
      </DefSale>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefPriceOld from '@components/Def/DefPriceOld/DefPriceOld.vue';
import DefPrice from '@components/Def/DefPrice/DefPrice.vue';
import DefPriceEN from '@components/Def/DefPrice/DefPriceEN.vue';
import DefSale from '@components/Def/DefSale/DefSale.vue';
import Analytics from '@/utils/Analytics';
import { useStore } from '@/store';

const { result } = defineProps(['result', 'messages']);

const getActiveSize = computed(() => result?.skuMatrix?.SIZES?.items?.find((el) => el.active));

const {
  state: {
    product: { data: productData },
  },
} = useStore();

const handlerClick = () => {
  Analytics.clickOnProduct(result);
};
</script>

<style lang="scss" scoped>
.product-modal {
  display: grid;
  grid-template-columns: 64px 1.3fr 1fr;
  grid-column-gap: 8px;
  grid-template-areas:
    'img description prices'
    'img size prices'
    'img count prices';
  padding: 12px 8px;
  border: 1px solid var(--border-grey);
  @include point-md {
    padding: 10px;
    grid-template-columns: 80px 1.5fr 1fr 1fr 1fr;
    grid-template-areas: 'img description size count prices';
    align-items: center;
  }
  :deep(.def-img) {
    grid-area: img;
  }
}
.product-modal-description {
  display: flex;
  flex-direction: column;
  grid-area: description;
  margin-bottom: 8px;
  @include point-md {
    margin-bottom: 0;
  }
  &__name {
    font-weight: 600;
    font-size: rem(14);
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin-bottom: 6px;
    @include point-md {
      font-size: rem(16);
    }
  }
  &__collection {
    font-weight: 400;
    font-size: rem(10);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--color-dark-grey);
    margin-bottom: 12px;
    @include point-md {
      margin-bottom: 10px;
      font-size: rem(12);
    }
  }
  &__article {
    font-weight: 400;
    font-size: rem(11);
    line-height: 110%;
    color: var(--color-dark-grey);
  }
}
.product-modal-prop {
  display: flex;
  @include point-md {
    flex-direction: column;
  }
  &__name {
    font-weight: 500;
    font-size: rem(12);
    line-height: 120%;
    @include point-md {
      font-size: rem(10);
      line-height: 100%;
      color: var(--color-dark-grey);
      margin-bottom: 6px;
    }
    &:after {
      content: ': ';
      margin-right: 2px;
      @include point-md {
        content: '';
      }
    }
  }
  &__value {
    font-weight: 500;
    font-size: rem(12);
    line-height: 120%;
    @include point-md {
      font-size: rem(16);
      line-height: 100%;
    }
  }
}
.product-modal-count {
  grid-area: count;
}
.product-modal-size {
  grid-area: size;
}
.product-modal-prices {
  display: flex;
  flex-direction: column;
  grid-area: prices;
  align-self: flex-end;
  justify-self: flex-end;
  text-align: end;
  :deep(.def-price-old) {
    font-size: rem(9);
    margin-bottom: 4px;
    @include point-md {
      font-size: rem(14);
    }
  }
  :deep(.def-price) {
    font-size: rem(14);
    margin-bottom: 6px;
    @include point-md {
      font-size: rem(18);
      margin-bottom: 8px;
    }
  }
  :deep(.def-price-en) {
    font-size: rem(14);
    margin-bottom: 6px;
    @include point-md {
      font-size: rem(18);
      margin-bottom: 8px;
    }
  }
  :deep(.def-sale) {
    font-size: rem(9);
    @include point-md {
      font-size: rem(11);
    }
  }
}
</style>
